export default __webpack_public_path__ + "static/media/envelope.a007fe4e.svg";